import '@fpsm/cxy-tokens/tokens.css';

import { type FunctionComponent } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Provider } from 'reakit';

import { useTranslation } from '@cx-modules/i18n-provider';

import { fetchOutrightsCouponData, getOutrightsCouponCacheKey } from './api/cx-api.service';
import { bettypeOutrightNamespaces } from './components/outright-markets/bettypeNamespaces';
import Outrights from './components/outrights';
import { type OutrightsCouponResponseData } from './interfaces/outright-markets.interface';
import { type OutrightsCouponProps } from './types';

const OutrightsComponent = ({ dataApiEndpoint, headerTitle, ...requestParams }: OutrightsCouponProps) => {
  const nsOrder = [...bettypeOutrightNamespaces, 'bettype', 'sports', 'label'];

  const { t } = useTranslation(nsOrder as any);
  const { data } = useSuspenseQuery<OutrightsCouponResponseData | null>({
    queryFn: () =>
      fetchOutrightsCouponData(dataApiEndpoint, requestParams, {
        logger: console,
      }),
    queryKey: getOutrightsCouponCacheKey(requestParams),
  });

  if (!data?.outrightMarkets?.length) return null;

  const translatedHeaderTitle = t(headerTitle ?? '');

  const firstEventIndex = 0;
  const eventHeaderTitle =
    requestParams.splitBy === 'EVENT'
      ? `${t(data.outrightMarkets[firstEventIndex]?.eventName)} ${translatedHeaderTitle}`
      : translatedHeaderTitle;

  return (
    <Outrights
      headerTitle={eventHeaderTitle}
      oddsShown={requestParams.oddsShown}
      outrightMarkets={data.outrightMarkets}
      repub={requestParams.repub}
      requestUrl={requestParams.requestUrl}
    />
  );
};

export const OutrightsCoupon: FunctionComponent<OutrightsCouponProps> = ({ eventIds, splitBy, ...props }) => {
  return (
    <Provider>
      {splitBy === 'EVENT' ? (
        eventIds.map(eventId => <OutrightsComponent eventIds={[eventId]} {...props} key={eventId} splitBy={splitBy} />)
      ) : (
        <OutrightsComponent {...props} eventIds={eventIds} splitBy={splitBy} />
      )}
    </Provider>
  );
};
